module.exports = __webpack_public_path__ + "652ce570e17b9d26515e10b2907966c8.png";